import get from 'lodash/get';
import React from 'react';

import { Button, SmallLogo } from 'modules/ui';
import { Colors } from 'modules/theme';

import { AuthPage } from '../components';
import { useLocation, useNavigate } from 'react-router-dom';

const styles = {
  container: {
    alignItems: 'center',
    textAlign: 'center',
  },
  descriptionTitle: {
    marginTop: '-10px',
    fontSize: '32px',
  },
  description: {
    color: Colors.darkGrey,
    lineHeight: '28px',
    maxWidth: '360px',
    margin: '25px 0 50px',
    fontSize: '16px',
  },
};

export default function SuccessPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const title = get(state, 'title');
  const description = get(state, 'description');

  const handleBackToAhab = () => navigate('/');

  if (!title && !description) {
    navigate('/login');
    return null;
  }

  return (
    <AuthPage
      className="pt-64"
      headerLink="/login"
      headerLinkLabel="Sign in"
      headerLinkDescription="Already have an account?"
      light
    >
      <div style={styles.container}>
        <SmallLogo />
        <h2 className="pt-48" style={styles.descriptionTitle}>
          {title}
        </h2>
        <p style={styles.description}>{description}</p>
        <Button primary style={styles.backButton} onClick={handleBackToAhab}>
          Go to Homepage
        </Button>
      </div>
    </AuthPage>
  );
}
